<div class="grid-container margin-top">
    <report-command [dateRequired]="false" [fromDate]="fromDate" [toDate]="toDate" [noDateLabel]="includePending" (reportGenerated)="generateReport($event)" (reportDownloaded)="downloadReport($event)"></report-command>
    <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="reportData" [excelStyles]="excelStyles" aria-label="Well Transfer Report"></ag-grid-angular>
</div>

